import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import Nav from './components/Nav';
import Hero from './components/Hero';
import WhatIDo from './components/WhatIDo';
import SelectedWork from './components/SelectedWork';
import AppsSection from './components/AppsSection';
import Testimonials from './components/Testimonials';
import CallToAction from './components/CallToAction';
import Footer from './components/Footer';
import SEO from './components/SEO';
import WorkListPage from './components/WorkListPage';
import WorkPage from './components/WorkPage';
import AppsPage from './components/AppsPage';
import AboutPage from './components/AboutPage';
import { initGA } from './utils/analytics';

// Home page component
const HomePage = () => (
  <>
    <SEO />
    <Hero />
    <WhatIDo />
    <SelectedWork />
    <AppsSection />
    <Testimonials />
    <CallToAction />
  </>
);

/**
 * /projects/:id -> /work/:id, except for the two entries that are no longer client
 * projects at all. Solidly Finance and Solidly Meet moved to /apps, so send those
 * there instead of to a work page that would 404.
 */
const APPS_MOVED_FROM_PROJECTS = ['solidly-finance', 'solidly-meet'];

const RedirectProjectToWork = () => {
  const { projectId } = useParams();

  if (APPS_MOVED_FROM_PROJECTS.includes(projectId)) {
    return <Navigate to="/apps" replace />;
  }

  return <Navigate to={`/work/${projectId}`} replace />;
};

function App() {
  useEffect(() => {
    // Initialize GA (ensures it's ready for tracking)
    initGA();
  }, []);

  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <Nav />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/work" element={<WorkListPage />} />
            <Route path="/work/:projectId" element={<WorkPage />} />
            <Route path="/apps" element={<AppsPage />} />
            <Route path="/about" element={<AboutPage />} />

            {/* Routes retired in the personal-site restructure. The old sitemap and any
                external links still point at these, so redirect rather than 404. */}
            <Route path="/projects" element={<Navigate to="/work" replace />} />
            <Route path="/projects/:projectId" element={<RedirectProjectToWork />} />
            <Route path="/services" element={<Navigate to="/about" replace />} />
            <Route path="/services/:serviceId" element={<Navigate to="/about" replace />} />

            {/* Unknown paths land on the homepage rather than a blank screen. */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
